import { render, staticRenderFns } from "./VideoPlayerV2.vue?vue&type=template&id=4d321420&scoped=true&"
import script from "./VideoPlayerV2.vue?vue&type=script&lang=ts&"
export * from "./VideoPlayerV2.vue?vue&type=script&lang=ts&"
import style0 from "./VideoPlayerV2.vue?vue&type=style&index=0&id=4d321420&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d321420",
  null
  
)

export default component.exports